module.exports = __webpack_public_path__ + "static/media/soccorso_stradale_axa_OLD.a1f98130.png";